import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { Company } from "@/types/company";

export const useFlagCompanyError = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const flagCompanyError = async (
    companyId: Company["id"],
    errorDetail: string,
  ) => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post(
        "companies/companies/flag_error/",
        {
          company_id: companyId,
          error_detail: errorDetail,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      setSuccess(response.data.message);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };
  return { flagCompanyError, loading, error, success };
};
